const FALLBACK_OUTPUT_ID = -1;
const UNSEEN_NODES_OUTPUT_ID = -222;

import {DimensionValue, MetricValue} from '../analytics/analytics.types';

enum CLInsightsType {
  General = 'General',
  SocialGeneral = 'SocialGeneral',
  Video = 'Video',
  Audio = 'Audio',
  Social = 'Social',
  Finance = 'Finance',
  ExternalData = 'External Data',
}

interface RemoteNodeInsightsData extends InsightsMetricsData {
  targetNodeId: number;
}

interface RemoteNodeInsightsDataWithSource extends RemoteNodeInsightsData {
  sourceNodeId: number;
  outputId: number;
}

type InsightsData = Partial<Record<MetricValue, number>>;

interface InsightsMetricsData {
  MetricsData: InsightsData;
}

interface NodeInsightsData {
  value: number;
  percentageOfTotal: number;
}

interface RemoteCampaignInsightsData {
  totals: InsightsMetricsData;
  insights: RemoteNodeInsightsDataWithSource[];
  nodeInsights: RemoteNodeInsightsData[];
}

interface NodeInsights {
  totals: Record<MetricValue, NodeInsightsData>;
  unseen?: Record<MetricValue, NodeInsightsData>;
  outputs?: Record<number, Record<string, NodeInsightsData>>;
}

interface CampaignInsightsData {
  totals: InsightsData;
  nodes: NodesInsightsOutputInputData;
}

interface NodesInsightsOutputInputData {
  outgoingData: Record<number, NodeInsights>;
  incomingData: Record<number, NodeInsights>;
}

interface InsightMetricsOption {
  id: number;
  name: string;
  isClinchInsightsMetric: boolean;
  metrics: MetricValue[];
  customConversions: MetricValue[];
}

type InsightsObj = Record<
  MetricValue,
  {value: number; percentageOfTotal: number; proportionalSize: number}
>;

interface RemoteAvailableMetricsForPreset {
  supportedMetrics: MetricValue[];
  supportedCustomConversion: MetricValue[];
}

interface RemoteAvailableFilter {
  category: string;
  value: DimensionValue;
}

type AvailableMetricsForPreset = Set<MetricValue>;

interface MetaCustomConversions {
  id: string;
  name: string;
}

enum InsightsSearchParamKey {
  Date = 'date',
  Metric = 'metric',
  Preset = 'preset',
  Filters = 'filters',
  Timezone = 'timezone',
}

interface RemoteGeneralStatistics {
  ActiveSince: string;
  Metrics: Record<MetricValue, number>;
}

export {
  AvailableMetricsForPreset,
  CLInsightsType,
  CampaignInsightsData,
  FALLBACK_OUTPUT_ID,
  InsightMetricsOption,
  InsightsData,
  InsightsMetricsData,
  InsightsObj,
  NodeInsights,
  NodeInsightsData,
  NodesInsightsOutputInputData,
  RemoteAvailableMetricsForPreset,
  RemoteCampaignInsightsData,
  RemoteNodeInsightsData,
  RemoteNodeInsightsDataWithSource,
  UNSEEN_NODES_OUTPUT_ID,
  RemoteAvailableFilter,
  MetaCustomConversions,
  InsightsSearchParamKey,
  RemoteGeneralStatistics,
};
